export const catalog=[
	{
		id: '0001',
		photo: [
			'cat/727968196a674de10287d1531c27f38a.jpg',
			'cat/amazing_black_ink_detailed_sketch_style_cat.jpg',
			'cat/black-cat-tattoo1.jpg',
			'cat/cat-drawing-arm-tattoo.jpg',
			'cat/cat-tattoo-designs-11041613.jpg',
			'cat/cat-tattoo-designs-11041614.jpg',
			'cat/cat-tattoo-yammy.jpg',
			'cat/cat-horitomo-2.jpg',
			'cat/My-buddy_rBo.jpg',
		],
		master: 'Cats'
	},
	{
		id: '0002',
		photo: [
			'lion/Abstract-Watercolor-Half-face-Lion-Tattoo-On-Upper-Back-1.jpg',
			'lion/chest-geometric-lion-tattoo-ideas-for-gentlemen.jpg',
			'lion/images.jpg',
			'lion/Lion-Tattoo-29.jpg',
			'lion/Lion-Tattoo-93-650x650.jpg',
			'lion/lion-tattoo-ideas-43.jpg',
			'lion/lion-tattoos-24.jpg',
			'lion/orig.jpg',
			'lion/Half-sleeve-lion-with-crown-tattoo.jpg',
		],
		master: 'Lions'
	},
	{
		id: '0003',
		photo: [
			'jesus/jesus-tattoo-21.jpg',
			'jesus/164-portret-iisusa-v-ramke.jpg',
			'jesus/077990363cf25d0c4e1e4914ad18c86b.jpg',
			'jesus/guy-with-half-sleeve-3d-jesus-tattoo-design.jpg',
			'jesus/guy-with-half-sleeve-3d-jesus-tattoo-design.jpg',
			'jesus/jesus-christ-tattoo-15.jpg',
			'jesus/Jesus-Christ-Tattoo-Design-by-ollievenegas-728x728.jpg',
			'jesus/jesus-tattoo-3.jpg',
			'jesus/jesus-with-a-halo-traditional-tattoo-594.jpg',
			'jesus/Powerful-religious-tattoo-Designs-to-Try-58.jpg',
			'jesus/Powerful-religious-tattoo-Designs-to-Try-60.jpg',
		],
		master: 'Jesus'
	},
	{
		id: '0004',
		photo: [
			'tree/3beb4e62f0072e7eccb206c3c549331b.jpg',
			'tree/53938.jpg',
			'tree/color-tree-tattoo-12.jpg',
			'tree/e0a94ff8d0fea7e21d1e1a71bc8c78e7.jpg',
			'tree/male-with-cool-tree-tattoos.jpg',
			'tree/orig.jpg',
			'tree/tree-tattoos-on-back-27.jpg',
			'tree/tumblr_oopx3kFunI1scmex7o1_500.jpg',
			'tree/tumblr_p74hqlw7n51sfoms5o1_500.jpg',
			'tree/Watercolor-Pine-Tree-Side-Body-Tattoo.jpg',
		],
		master: 'Tree'
	},
	{
		id: '0005',
		photo: [
			'music/large.jpg',
			'music/a190c3d5673ce65b85660bad6f3b9e55.jpg',
			'music/aabe1beddf22b4a98261263b4a03bbac.jpg',
			'music/adee3498516c518d736455d254e54a28.jpg',
			'music/hinh-xam-nho-mini-dep-15.jpg',
			'music/aa.jpg',
			'music/Music-tattoo-designs-4.jpg',
			'music/Music-Tattoos-23.jpg',
			'music/version.medium.jpg',
		],
		master: 'Music'
	},
	{
		id: '0006',
		photo: [
			'rose/image2.jpeg',
			'rose/3d_rose_shoulder.jpg',
			'rose/50-Of-The-Most-Beautiful-Rose-Tattoos-3.jpg',
			'rose/18166.jpg',
			'rose/2581135a4ed7c8fc6148fae1a9cd0569.jpg',
			'rose/article-2401903-1B728FE7000005DC-767_634x635.jpg',
			'rose/Burning-Rose-Tattoo-by-Andrés-Acosta-728x728.jpg',
			'rose/Gorgeous-Rose-Tattoo-Designs-For-Women-10.jpg',
			'rose/Realistic-3D-Red-Roses-Tattoo-On-Girl-Half-Sleeve.jpg',
			'rose/rose-tattoos-28.jpg',
			'rose/003.jpg',
			'rose/stylish-mens-badass-flower-rose-tattoos.jpg',
		],
		master: 'Roses'
	},
	{
		id: '0007',
		photo: [
			'chamomile/677f8752d650900449303e797199c55e.jpg',
			'chamomile/13991.jpg',
			'chamomile/33772.jpg',
			'chamomile/daisy-032.jpg',
			'chamomile/images.jpg',
			'chamomile/photo25234_water.jpg',
			'chamomile/tattoo-camomile-6w4jeanfs.jpg',
		],
		master: 'Сhamomilies'
	},
	{
		id: '0008',
		photo: [
			'star/traditional-nautical-stars-mens-chest-and-shoulder-tattoos.jpg',
			'star/Moon-and-Stars-Tattoo-idea.jpg',
			'star/Scenery-Filled-Stars-Arm-Tattoo.jpg',
			'star/stars-tattoo-115462-9600498.jpg',
			'star/Star-Tattoos_-30.jpg',
			'star/star-tattoos-3001186.jpg',
			'star/Star-tattoos-on-instep.jpg',
			'star/Star-Tattoos-tattooeasily-23.jpg',
		],
		master: 'Stars'
	},
	{
		id: '0009',
		photo: [
			'clock/0a355c3ed6091162ae942c8e29da6694.jpg',
			'clock/2e1b5c54191cb91f4abff2187d11b624.jpg',
			'clock/clock-and-rose-tattoo-by-Andres-Acosta.jpg',
			'clock/clock-tattoo-designs-6.jpg',
			'clock/clock-tattoo-for-men.jpg',
			'clock/clock-tattoo-photo-39.jpg',
			'clock/f6365e69c0964ca68783152e25136285--clock-tattoos-clocks.jpg',
			'clock/male-clocks-tattoos.jpg',
			'clock/Old-pocket-watch-tattoo-64.jpg',
			'clock/pocket_watch_by_bobeck-d48h1ca.jpg',
		],
		master: 'Clocks'
	},
	{
		id: '0010',
		photo: [
			'motorcycle/Без названия.jpg',
			'motorcycle/8a7690e27b942e2a51a6ebdda31bae81.jpg',
			'motorcycle/29-tattoo-motorcycle-piston.jpg',
			'motorcycle/92cbbfd8197db544f3057b1d5c8bee9e.jpg',
			'motorcycle/e47d53746adc713f417b12df816f7468.jpg',
			'motorcycle/orig.jpg',
			'motorcycle/Piston-and-Wrench-Tattoo-Designs-by-gladeyery-510x510.jpg',
			'motorcycle/vintage_motorcycle_race_tattoo_by_tuomaskoivurinne-danhcn6.jpg',
		],
		master: 'Motorcycle'
	},
	{
		id: '0011',
		photo: [
			'deer/black-ink-deer-head-mens-chest-tattoo.jpg',
			'deer/88db889e4f84dc997a09f4d5cb99eddf.jpg',
			'deer/bf50163b3594c89d2c237475af2f8f98.png',
			'deer/cool-stag-tattoo.jpg',
			'deer/deer-tattoo-26.jpg',
			'deer/Deer-tattoo-62.jpg',
			'deer/deer-tattoo-10845.jpg',
			'deer/mens-back-tattoos-of-abstract-deer-design.jpg',
			'deer/thigh-tattoo-deer.jpg',
		],
		master: 'Deer'
	},
	{
		id: '0012',
		photo: [
			'bird/eagle-tattoo-designs-41.jpg',
			'bird/596967a6-c1a4-ade3-2e62-5ab4c84702ee.jpg',
			'bird/bird-tattoos-1.jpg',
			'bird/bird-tattoos-150-5810c075db95e__700.jpg',
			'bird/f05d7959f7a6729816184b92b2d6d4fb--tattoo-neck-chest-tattoo.jpg',
			'bird/Swallow-Bird-Tattoo-72-765x765.jpg',
			'bird/Swallow-Bird-Tattoo-79-765x626.jpg',
			'bird/tumblr_npn8r7aapq1rwpvelo1_540.jpg',
		],
		master: 'Birds'
	},
	{
		id: '0013',
		photo: [
			'heart/heart-tattoos-designs-78.jpg',
			'heart/heart-tattoo-1-650x488.jpg',
			'heart/8f87faf7bd78b15c096b0b9c023ab33f.jpg',
			'heart/997019-1000232940000973-2286909807858371521-n-1-jpg.jpg',
			'heart/artist--steve-newman--heart-tattoo_17136180502.jpg',
			'heart/followthecoloursdotcomdotbr1.jpg',
			'heart/kdCdxEk.jpg',
			'heart/watercolor-heart-tattoo.jpg',
		],
		master: 'Hearts'
	},
	{
		id: '0014',
		photo: [
			'earth/8034fcd195b0c1abf5ea39568a01e58d.jpg',
			'earth/3fb3c9707fadbee2ee3db1d38ffd6a90.jpg',
			'earth/74d4095aeda617db6cdc4b660397e9c3.jpg',
			'earth/16367385373_8fcff25248_b.jpg',
			'earth/b873f12053be934dde3569f51b1ab0f9.jpg',
			'earth/Black-and-white-shaded-earth-tattoo-with-compass-on-inner-arm.jpg',
			'earth/of5zllofhzhusraqqb2leixxxl4j3hpexhjnof_p3ymrypkwj94qgrtdb3sbc6ky.jpg',
		],
		master: 'Earth'
	},
	{
		id: '0015',
		photo: [
			'ship/Blue-Ship-Pirate-Tattoo.jpg',
			'ship/awesome-ship-tattoo-14910727194nk8g.jpg',
			'ship/Boat-sleeve-tattoo-for-men-91.jpg',
			'ship/d9ea06c159267a49e67f15b40de2d961.jpg',
			'ship/mens-center-of-back-traditional-sailing-ship-with-rose-flower-tattoo-design.jpg',
			'ship/Pirate-Ship-Tattoo-88-765x956.jpg',
			'ship/sailor-beard-sailing-ship.jpg',
			'ship/Ship-Tattoo-00.jpg',
			'ship/ship-tattoo-10.jpg',
		],
		master: 'Ships'
	},
	{
		id: '0016',
		photo: [
			'food/orig (1).jpg',
			'food/1c971cee4e2d236fe56e11ebe7e5e851.jpg',
			'food/food6.jpg',
			'food/food-tattoo-designs-1.jpg',
			'food/images (1).jpg',
			'food/images (2).jpg',
			'food/images.jpg',
			'food/orig.jpg',
			'food/Без названия.jpg',
		],
		master: 'Food'
	},
	{
		id: '0017',
		photo: [
			'sport/6232b0f9ac5f816f919c5cd07e10860b.jpg',
			'sport/37074559_242781556533238_2882946447538388992_n.jpg',
			'sport/Baseball-Tattoo-2.jpg',
			'sport/guys-soccer-goalie-gloves-tattoo-on-forearm.jpg',
			'sport/images (1).jpg',
			'sport/images.jpg',
			'sport/large.jpg',
			'sport/tennis-mens-tattoo-sports-design.jpg',
		],
		master: 'Sport'
	},
	{
		id: '0018',
		photo: [
			'dragon/3ddf337949001bfe03bc6684516091ec--pokemon-nintendo-medieval.jpg',
			'dragon/chinese-dragon-tattoos-for-men.jpg',
			'dragon/dragon-01.jpg',
			'dragon/dragon-tattoo-design-2.jpg',
			'dragon/images (1).jpg',
			'dragon/images (2).jpg',
			'dragon/images (3).jpg',
			'dragon/images (4).jpg',
			'dragon/images (5).jpg',
			'dragon/images.jpg',
		],
		master: 'Dragons'
	},
	{
		id: '0019',
		photo: [
			'anime/ss.jpg',
			'anime/XX-Studio-Ghibli-Inspired-Tattoos-26__700.jpg',
			'anime/studio-ghibli-tattoos-2.jpg',
			'anime/lal.jpg',
			'anime/images (9).jpg',
			'anime/images (8).jpg',
			'anime/images (7).jpg',
			'anime/images (6).jpg',
			'anime/50-Anime-Tattoos.jpg',
			'anime/9fe1d26eaff98c35829f1d1645805a28eeec158c_hq.jpg',
		],
		master: 'Anime'
	},
	{
		id: '0020',
		photo: [
			'word/37-Forearm-Quote-Tattoos.jpg',
			'word/e292dea495d5df6fcc07b606e6bb7a85.jpg',
			'word/images (1).jpg',
			'word/images (2).jpg',
			'word/images (3).jpg',
			'word/images (4).jpg',
			'word/images (5).jpg',
			'word/images (6).jpg',
			'word/images.jpg',
			'word/word-tattoo-2.jpg',
		],
		master: 'Words'
	},
];